import React, {useState} from 'react';

import Button from '@mui/material/Button';

import {
  getStates,
  getReferralSourceCategories,
} from '../../helpers/selectOptions';
import config from '../../config/config';
import CustomPagination from '../common/CustomPagination';
import LeadStatus from './LeadStatus';
import LeadDialog from './LeadDialog';
import SpreadSheet from '../common/SpreadSheet';
import {useUpdateLeadMutation} from '../../redux/services/leadApi';
import {formatDate} from '../../helpers/dates';

const getColumns = ({onOpenLeadDialog}) => [
  {
    label: 'Status',
    key: 'status',
    type: 'Component',
    minWidth: 150,
    Component: ({row}) => (
      <LeadStatus lead={row.data} includeStep={true} />
    ),
  },
  {
    label: 'Name',
    key: 'contact_first_name',
    type: 'text',
    minWidth: 100,
    Component: ({row}) => (
      <div 
        onClick={() => onOpenLeadDialog(row.id)} 
        style={{cursor: 'pointer', color: config().colors.primary, fontWeight: 'bold'}}
      >
          {row.data.contact_first_name} {row.data.contact_last_name}
      </div>
    ),
  },
  {
    label: 'Email',
    key: 'contact_email',
    type: 'email',
    minWidth: 200,
    Component: ({row}) => (
      <strong>{row.data.contact_email}</strong>
    ),
  },
  {
    label: 'Created At',
    key: 'date_created',
    type: 'Component',
    minWidth: 100,
    Component: ({row}) => (
      <strong>
        {formatDate(row.data.date_created)}
      </strong>
    ),
  },
  {
    label: 'Updated At',
    key: 'date_updated',
    type: 'Component',
    minWidth: 100,
    Component: ({row}) => (
      <strong>
        {formatDate(row.data.date_updated)}
      </strong>
    ),
  },
  // {
  //   label: 'Phone',
  //   key: 'contact_phone',
  //   type: 'phone',
  //   hideLabel: true,
  //   minWidth: 150,
  // },
  {
    label: 'Team',
    key: 'team_id',
    type: 'selectTeam',
    hideLabel: true,
    minWidth: 150,
  },
  {
    label: 'Provider',
    key: 'provider_id',
    type: 'selectProvider',
    hideLabel: true,
    minWidth: 150,
  },
  // {
  //   label: 'City',
  //   key: 'contact_city',
  //   type: 'text',
  //   minWidth: 150,
  // },
  // {
  //   label: 'State',
  //   key: 'contact_state',
  //   type: 'select',
  //   options: getStates(),
  //   minWidth: 50,
  // },
  // {
  //   label: 'diagnosis_category_id',
  //   label: 'Diagnosis Category',
  //   type: 'select',
  //   editableAfterCreate: true,
  //   required: false,
  //   fullWidth: true,
  //   validate: () => true,
  //   options: (diagnosisCategories || []).map(
  //     c => ({value: c.id, label: c.name})
  //   ),
  //   grid: {
  //     xs: 12,
  //     md: 6,
  //   },
  // },
  {
    key: 'referral_category',
    label: 'Lead Source Category',
    type: 'select',
    minWidth: 200,
    options: getReferralSourceCategories().map(c => ({
      value: c.value.toUpperCase(), 
      label: c.value.toUpperCase(),
      disabled: !!c?.disabled,
    })),
  },
  {
    key: 'referrer_id',
    label: 'Lead Source',
    type: 'selectReferrer',
    minWidth: 200,
    allowCreateNew: false,
  },
  {
    key: 'lead_source_company_id',
    label: 'Lead Source Company',
    type: 'selectReferrerCompany',
    disabled: false,
    minWidth: 200,
    allowCreateNew: false,
  },
  {
    key: 'referrer_raw',
    label: 'Patient-Reported Lead Source',
    type: 'text',
    minWidth: 200,
    disabled: true,
  },
  {
    key: 'referral_category_raw',
    label: 'Patient-Reported Category',
    type: 'select',
    minWidth: 200,
    disabled: true,
    options: getReferralSourceCategories().map(c => ({
      value: c.value.toUpperCase(), 
      label: c.value.toUpperCase(),
      disabled: !!c?.disabled,
    })),
  },
  {
    key: 'lost_category',
    label: 'Reason Lost (Category)',
    type: 'select',
    minWidth: 175,
    options: [
      {value: 'COST', label: 'Insurance or Cost Objection'},
      {value: 'GHOSTED', label: 'Ghosted! (No Response)'},
      {value: 'TIMING', label: 'Timing Not Right'},
      {value: 'DISTANCE', label: 'Outside of Treatment Radius'},
      {value: 'RESOLVED', label: 'Pain Resolved'},
      {value: 'REFERRED_OUT', label: 'Referred Out'},
      {value: 'OTHER', label: 'Other Reason (please note in comment)'},
    ].map(({value, label}) => ({value, label: value})),
  },
  // {
  //   key: 'why_lost',
  //   label: 'Reason Lost (Comment)',
  //   type: 'textarea',
  //   minWidth: 150,
  //   rows: 3,
  // },
];

const LeadSpreadsheet = props => {
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [put] = useUpdateLeadMutation();
  const mappedRows = (props.rows || []).map(r => ({
    ...r,
    data: {
      ...r.data, 
      lead_source_company_id: r.data?.referrer?.company?.id || null,
      provider_id: r.data?.provider_id || r.data?.provider?.id || null,
      team_id: r.data?.team_id || r.data?.team?.id || null,
    }
  }));
  return (
    <>
      <LeadDialog
        leadId={selectedLeadId}
        dialogIsOpen={!!selectedLeadId}
        onClose={() => {
          setSelectedLeadId(null);
        }}
      />
      <SpreadSheet
        rows={mappedRows}
        columns={getColumns({
          onOpenLeadDialog: (leadId) => setSelectedLeadId(leadId)
        })}
        put={put}
      />
      <CustomPagination
        pageSize={props.pageSize}
        pageIndex={props.pageIndex}
        count={props.count}
        onPageChange={(e,num) => props.onPageChange(e, num)}
      />
    </>
  );
};

export default LeadSpreadsheet;